import VehicleList from '@/api/master/VehicleList'
import Functions from '@/functions'

export default {
  namespaced: true,
  state: {
    total: 0,
    data: [],
    select: []
  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data.data
      state.total = data.total
    },
    SET_SELECT_OPTIONS(state, data) {
      state.select = data
    }
  },
  actions: {
    datatable({ commit }, params) {
      return VehicleList.datatable(params)
        .then((res) => {
          commit('SET_DATA', res.data.message)
        })
        .catch((error) => {
          Functions.httpErrorHandler(error)
          return { status: false, message: null }
        })
    },
    detail({}, id) {
      return VehicleList.detail(id)
        .then((res) => {
          const { data } = res.data.message
          return data
        })
        .catch((error) => {
          Functions.httpErrorHandler(error)
          return { status: false, message: null }
        })
    },
    list_brand() {
      return VehicleList.list_brand()
        .then((res) => {
          return res.data.message.data
        })
        .catch((error) => {
          Functions.httpErrorHandler(error)
          return { status: false, message: null }
        })
    },
    list_type() {
      return VehicleList.list_type()
        .then((res) => {
          return res.data.message.data
        })
        .catch((error) => {
          Functions.httpErrorHandler(error)
          return { status: false, message: null }
        })
    },
    store({}, data) {
      return VehicleList.store(data)
        .then((res) => {
          return res.data
        })
        .catch((error) => {
          Functions.httpErrorHandler(error)
          return { status: false, message: null }
        })
    },
    update({}, { id, ...data }) {
      return VehicleList.update(id, data)
        .then((res) => {
          return res.data
        })
        .catch((error) => {
          Functions.httpErrorHandler(error)
          return { status: false, message: null }
        })
    },
    delete({}, id) {
      return VehicleList.delete(id)
        .then((res) => {
          return res.data
        })
        .catch((error) => {
          Functions.httpErrorHandler(error)
          return { status: false, message: null }
        })
    }
  },
  getters: {}
}
